import { numberAndStringRegex, NumberRegExError } from "./types";

export default function validateBicCode(item: string) {
  if (!item || !item.length) {
    return NumberRegExError.MISSING;
  }

  const numberRegexTester = new RegExp(numberAndStringRegex);

  const result = numberRegexTester.test(item);

  if (result && item.length > 11) {
    return NumberRegExError.MAX_LENGTH;
  }

  return result ? NumberRegExError.VALID : NumberRegExError.INVALID;
}
